module.exports = __webpack_public_path__ + "static/z16-PUCK_UJECIE_1-096a98d8ea667f8d4a7d36ed769011e9.jpg";